import resume from '../assets/pdf/resume.pdf'
import profileImg from '../assets/images/talha.png';

export const headerData = {
    name: 'Talha Khan',
    title: "PHP | Laravel | WordPress Developer",
    desciption: "I’m a passionate developer with hands-on experience in Laravel and WordPress. I enjoy building clean, scalable, and user-friendly web applications that make a real impact.",
    image: profileImg,
    resumePdf: resume
}

